import { themes } from './themes';

const DEFAULT_THEME = 'Default';

export default {
  defaultTheme: DEFAULT_THEME,
  themes: themes
};
